import { SupportFormPayload } from './../model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiFacadeService } from '@app/services/api-facade.service';

interface ActiveProductsResponse {
	product_permissions: {
		commitment_manager: boolean;
		zesty_disk: boolean;
		Kompass: boolean;
	};
}

@Injectable()
export class SupportModalService {
	public reqUrl = 'integrations/support-form';

	constructor(private httpService: ApiFacadeService) {}

	public submitCase(supportPayload: SupportFormPayload): Observable<{ errors: []; success: boolean; id: string }> {
		return this.httpService.post<{ errors: []; success: boolean; id: string }>(this.reqUrl, supportPayload);
	}

	public getActiveProducts(): Observable<ActiveProductsResponse> {
		return this.httpService.get<ActiveProductsResponse>('platform/account/get-products-status');
	}
}
